import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { Prodotto } from '../_model/prodotto.model';
import { Cliente } from '../_model/cliente.model';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class StepsDataService {
	prodottoPrincipale: Prodotto = JSON.parse(sessionStorage.getItem('prodottoSelezionato') as string) ?? ({} as Prodotto);
	prodottiAggiuntivi: Prodotto[] = JSON.parse(sessionStorage.getItem('prodottiAggiuntiviSel') as string) ?? [];

	private prodottoPrincipaleSubject = new BehaviorSubject<Prodotto>(this.prodottoPrincipale);
	prodotto$ = this.prodottoPrincipaleSubject.asObservable();

	private prodottiAggiuntiviSubject = new BehaviorSubject<Prodotto[]>(this.prodottiAggiuntivi);
	prodottoAgg$ = this.prodottiAggiuntiviSubject.asObservable();

	customer: Cliente = JSON.parse(sessionStorage.getItem('customer') as string) ?? ({} as Cliente);
	tutoreLegale: Cliente | null = JSON.parse(sessionStorage.getItem('tutoreLegale') as string) ?? null;

	private customerSubject = new BehaviorSubject<Cliente>(this.customer);
	customer$ = this.customerSubject.asObservable();

	private tutoreLegaleSubject = new BehaviorSubject<Cliente | null>(this.tutoreLegale);
	tutoreLegale$ = this.tutoreLegaleSubject.asObservable();

	private numCarrelloSubject = new BehaviorSubject<number>(this.calcolaNumCarrello());
	numCarrello$ = this.numCarrelloSubject.asObservable();

	setCustomer(customer: Cliente, isTutore: boolean) {
		if (isTutore) {
			this.tutoreLegale = customer;
			sessionStorage.setItem('tutoreLegale', JSON.stringify(customer));
			this.tutoreLegaleSubject.next(customer);
		} else {
			this.customer = customer;
			sessionStorage.setItem('customer', JSON.stringify(customer));
			this.customerSubject.next(customer);
		}
	}

	getCustomer(isTutore: boolean): Cliente | null {
		if (isTutore) {
			return this.tutoreLegaleSubject.value;
		} else {
			return this.customerSubject.value;
		}
	}

	clearCustomers() {
		sessionStorage.removeItem('customer');
		sessionStorage.removeItem('tutoreLegale');
	}

	setProdotto(prodotto: Prodotto) {
		this.prodottoPrincipale = prodotto;
		sessionStorage.setItem('prodottoSelezionato', JSON.stringify(prodotto));
		this.prodottoPrincipaleSubject.next(prodotto);
		this.numCarrelloSubject.next(this.calcolaNumCarrello());
	}

	setProdottiAgg(prodotti: Prodotto[]) {
		this.prodottiAggiuntivi = prodotti;
		sessionStorage.setItem('prodottiAggiuntiviSel', JSON.stringify(prodotti));
		this.prodottiAggiuntiviSubject.next(prodotti);
		this.numCarrelloSubject.next(this.calcolaNumCarrello());
	}

	private calcolaNumCarrello(): number {
		const numAggiuntivi = this.prodottiAggiuntivi?.length ?? 0;
		const hasPrincipale = this.prodottoPrincipale ? 1 : 0;
		return hasPrincipale + numAggiuntivi;
	}

	totale$ = combineLatest([this.prodotto$, this.prodottoAgg$]).pipe(
		map(([principale, aggiuntivi]) => {
			const prezzoPrincipale = principale?.prezzo ?? principale?.subtotal ?? 0;
			const prezzoAggiuntivi = aggiuntivi?.reduce((sum, p) => sum + (p.prezzo ?? p.subtotal ?? 0), 0) ?? 0;
			return prezzoPrincipale + prezzoAggiuntivi;
		}),
	);

	iniziaNuovoPreventivo() {
		this.prodottoPrincipale = {} as Prodotto;
		this.customer = {} as Cliente;
		this.tutoreLegale = null;
		this.prodottiAggiuntivi = [];
		this.prodottoPrincipaleSubject.next(this.prodottoPrincipale);
		this.prodottiAggiuntiviSubject.next(this.prodottiAggiuntivi);
		this.customerSubject.next(this.customer);
		this.tutoreLegaleSubject.next(this.tutoreLegale);
		this.numCarrelloSubject.next(0);
	}
}

export function restoreSession() {
	sessionStorage.removeItem('parameterOptionSelezionato');
	sessionStorage.removeItem('parametriProdotto');
	sessionStorage.removeItem('prodottoSelezionato');
	sessionStorage.removeItem('prodottiAggiuntiviSel');
	sessionStorage.removeItem('quoteId');
	sessionStorage.removeItem('total');
	sessionStorage.removeItem('dettaglioQuote');
	sessionStorage.removeItem('validateContacts');
	sessionStorage.removeItem('routePrecedente');
	sessionStorage.removeItem('customer');
	sessionStorage.removeItem('tutoreLegale');
	sessionStorage.removeItem('validation');
	localStorage.removeItem('step-progress');
}
